/**
 * @author Nihar<nihar.baishya@314ecorp.com>
 * @description React Hook useUpdateClaimActivityAction
 */
import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';

import api from 'client/index';
import AppEvents from '@veritable/common/utils/appEvents';
import QUERY_KEYS from 'app-constants/queryKeys';

/**
 * Mutate for update claim activity action
 *
 */
interface IProps {
	model: ClaimRequest.IActivityTypeUpdateRequest;
}
const useUpdateClaimActivityAction = (): UseMutationResult<unknown, IAxiosError, IProps, unknown> => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: async ({ model }) => {
			await api.ActivityTypeApi.patchActivityType(model);
		},
		onSuccess: () => {
			AppEvents.publishApiSuccess();
			setTimeout(() => {
				queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.claimActivityType] });
			});
		},
		onError: (error) => {
			AppEvents.publishApiError({ error });
		},
	});
};

export default useUpdateClaimActivityAction;
